<template>
  <div>

      <!----select stages ----->
      <div class="row">
        <div class="col-md-12">
          <button type="button"
                  class="btn btn-light btn-sm back"
                  @click.prevent="hideTasks(true)">
            <i class="material-icons mdc-button__icon">arrow_back</i>
            <span>{{'buttons.back' | trans}}</span>
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <h1 v-if="isNew && !protocol.isDraft" class="page-title">
            {{'protocol.newProtocol' |
            trans}}</h1>
          <h1 v-if="!isNew && !protocol.isDraft" class="page-title">
            {{'protocol.editProtocol' |
            trans}}</h1>
          <h1 v-if="protocol.isDraft" class="page-title">
            {{'protocol.auto_save_version' | trans}} {{protocol.updatedAt.date |
            toLocaleDateTime}}</h1>
          <h3 class="page-sub-title">
            {{currentStage.title}}: {{currentStage.description}}</h3>
        </div>
      </div>

      <!---- select task types ----->

      <div class="alert alert-secondary mt-2">
        <div class="form-group row">
          <div class="col-md-12">
            <h4 class="row-title">{{'protocol.stimuluses' | trans}}</h4>
            <h5 class="row-title_subsitle mb-4">{{'protocol.change_stimul_position' | trans}}</h5>
          </div>

          <div class="tasks col-md-12" id="tasks" v-if="tasks">
            <div>
                {{'protocol.stimul_settings' | trans}}
                <button type="button"
                        :disabled="!stimulListToChangeAndActive"
                        class="btn btn-link secondary-link btn-sm float-right"
                        @click.prevent="onEditSomeBtnClick()">
                  {{'protocol.buttons.edit' | trans}}
                </button>
            </div>
            <table class="table table-sm" v-if="!isMobile">
              <thead>

              <tr>
                <th>{{'protocol.stimulus_name' | trans}}</th>
                <th></th>
                <th>{{'protocol.show_on_stage' | trans}}</th>
                <th colspan="2">{{'user.edit' | trans}}</th>
                <th></th>
              </tr>

              </thead>

                <draggable
                    :list="tasks"
                    ghost-class="ghost"
                    tag="tbody"
                    @start="dragging = true"
                    @end="dragging = false"
                    handle=".drag-btn"
                >
                  <tr v-for="task in tasks" :key="task.id">
                    <td class="name-field">
                      {{task.description}}
                    </td>
                    <td>
                      
                      <span v-if="task.fieldIndex && task.phaseType != 3">{{'protocol.field' | trans}} {{task.fieldIndex}} / </span>
                      <span v-if="task.phaseType == 3 && currentIntervalType(task.intervalType)">{{currentIntervalType(task.intervalType)}} / </span>
                      <span v-if="!task.phaseType || task.phaseType == 1">{{'protocol.phase_mastering' | trans}}</span>
                      <span v-if="task.phaseType == 2">{{'protocol.phase_rotation' | trans}}</span>
                      <span v-if="task.phaseType == 3">{{'protocol.phase_support' | trans}}</span>
                      <span v-if="task.phaseType == 4">{{'protocol.phase_fluency' | trans}}</span>
                    </td>
                    <td class="table-actions">
                      <mdc-checkbox v-model="task.active"  @change="acivatedTask(task)" />
                    </td>
                    <td class="text-right action-cell">

                      <button type="button"
                              class="btn btn-primary btn-sm btn-rounded"
                              :disabled="!task.active"
                              @click.prevent="onEditBtnClick(task)">
                        <i class="material-icons button-primary btn-fixed">edit</i>
                      </button>
                    </td>
                    <td class="table-actions">
                      <mdc-checkbox v-model="task.changed" :disabled="!task.active"/>
                    </td>
                    <td class="text-right action-cell">
                      <span class="drag-btn align-top"  v-if="task.active">draggable</span>
                    </td>
                  </tr>
                </draggable>
            </table>

            <div class="mobile-table mt-3 mb-3"  v-if="isMobile">
              <div class="mobile-table__head">
                <div class="cell">{{'protocol.stimulus_name' | trans}}</div>
                <div class="cell">{{'protocol.show_on_stage' | trans}}</div>
              </div>

              <div class="mobile-table__body">
                <div class="mobile-table__row" v-for="task in tasks" :key="task.id">

                  <div>
                    <div class="cell">{{task.description}}</div>
                    <div class="cell">
                      <mdc-checkbox v-model="task.active"  @change="acivatedTask(task)" />
                    </div>
                  </div>
                  <div>

                  </div>

                  <div class="mt-3">
                    <p class="gray-700">
                      <span v-if="task.fieldIndex && task.phaseType != 3">{{'protocol.field' | trans}} {{task.fieldIndex}} / </span>
                      <span v-if="task.phaseType == 3 && currentIntervalType(task.intervalType)">{{currentIntervalType(task.intervalType)}} / </span>
                      <span v-if="!task.phaseType || task.phaseType == 1">{{'protocol.phase_mastering' | trans}}</span>
                      <span v-if="task.phaseType == 2">{{'protocol.phase_rotation' | trans}}</span>
                      <span v-if="task.phaseType == 3">{{'protocol.phase_support' | trans}}</span>
                      <span v-if="task.phaseType == 4">{{'protocol.phase_fluency' | trans}}</span>
                    </p>
                  </div>

                  <div class="mt-2">

                    <div class="cell">{{'user.edit' | trans}}</div>

                    <div class="cell">
                      <mdc-checkbox class="d-inline-block" v-model="task.changed" :disabled="!task.active"/>
                      <button type="button"
                              style="margin-top: -16px;"
                              class="btn btn-primary btn-sm btn-rounded d-inline-block"
                              :disabled="!task.active"
                              @click.prevent="onEditBtnClick(task)">
                        <i class="material-icons button-primary btn-fixed">edit</i>
                      </button>
                    </div>
                  </div>

                </div>
              </div>


            </div>
            <div>
              {{'protocol.stimul_settings' | trans}}
              <button type="button"
                      :disabled="!stimulListToChangeAndActive"
                      class="btn btn-link secondary-link btn-sm float-right"
                      @click.prevent="onEditSomeBtnClick()">
                {{'protocol.buttons.edit' | trans}}
              </button>
            </div>
          </div>

          <div class="col-10 col-md-11">
            <mdc-textfield type="text"
                           :label="'protocol.buttons.addStimulus' | trans"
                           name="addStimulusItem"
                           :class="{'is-invalid': errors.has('addStimulusItem')}"
                           v-validate="'max:1000'"
                           v-model="addStimulusItem"
                           data-vv-validate-on="none"
                           :data-vv-as="'protocol.buttons.addStimulus' | trans"/>
            <span class="invalid-feedback"
                  v-if="errors.has('addStimulusItem')">
                      <strong>{{ errors.first('addStimulusItem') }}</strong>
                  </span>

          </div>
          <div class="col-2 col-md-1">
            <button type="button"
                    class="btn btn-sm btn-rounded btn-add-grey"
                    @click.prevent="addTask(addStimulusItem)">
              <i class="material-icons button-primary btn-fixed">add</i>
            </button>
          </div>

          <!----------- tasks ------------------->
        </div>
      </div>


      <div class="form-group row">

        <div class="col-md-12 mt-4">
          <h4 class="row-title">
            {{'protocol.dtt_phase_title' | trans}}
          </h4>
          <strong v-if="errorPhaseCount" id="errorPhase" ref="errorPhase" class="invalid-feedback invalid">{{'protocol.errorPhaseCount' | trans}}</strong>
        </div>

        <div class="col-md-12 mt-3">

          <div class="box-shadow"  v-if="protocol.stages[currentStageIndex]">
            <div class="row">

              <div class="col-12"><h4 class="row-title">
                {{'protocol.setup_mastering' | trans}}: <mdc-switch v-model="masteringActive"/>
                <mdc-checkbox v-if="masteringActive" v-model="mastering.withFields" class="float-right" :label="'protocol.withFields' | trans"/>
              </h4></div>

              <div class="col-12" v-if="masteringActive">
                <div class="row">
                  <div class="col-md-4 required">
                    <v-select name="taskType"
                              ref="taskType"
                              id="taskType"
                              :options="taskTypesList"
                              label="title"
                              :class="{'is-clear': !masteringTaskType, 'is-invalid': errors.has('taskTypes')}"
                              v-validate="'required'"
                              data-vv-validate-on="none"
                              v-model=masteringTaskType
                              :data-vv-as="'protocol.task_type' | trans">
                      <template slot="no-options">
                        <div @mousedown.stop="">
                          {{ 'protocol.no_data' | trans }}
                        </div>
                      </template>
                    </v-select>
                    <label class="mdc-floating-label" :class="{'is-invalid': errors.has('taskType')}">{{'protocol.task_type' |
                      trans}} <sup><mdc-icon class="help_icon" icon="help"  v-tooltip.top-center="msg"></mdc-icon></sup></label>
                    <span class="invalid-feedback"
                          v-if="errors.has('taskType')">
                                    <strong>{{ errors.first('taskType') }}</strong>
                                </span>
                  </div>

                  <div class="col-md-4" v-if="mastering.withFields">

                      <label class="mdc-label">{{'protocol.min_field_count' | trans}}</label>
                      <input id="minFieldCount_mastering"
                             ref="minFieldCount_mastering"
                             min=1
                             max=15
                             v-on:keydown="changeNumberMax($event, 1)"
                             v-on:change="changeMinFieldCount(masteringMinFieldCount,1)"
                             :label="'protocol.min_field_count' | trans"
                             type="number"
                             name="minFieldCount_mastering"
                             :class="{'is-invalid': errors.has('minFieldCount_mastering')}"
                             v-validate="'min_value:1|max_value:15|numeric'"
                             v-model.number="masteringMinFieldCount"
                             data-vv-validate-on="none"
                             :data-vv-as="'validation.attributes.protocol.min_field_count' | trans"/>
                      <span class="invalid-feedback"
                            v-if="errors.has('minFieldCount_mastering')">
                                <strong>{{ errors.first('minFieldCount_mastering') }}</strong>
                            </span>

                  </div>

                  <div class="col-md-4"  v-if="mastering.withFields">
                    <label class="mdc-label">{{'protocol.max_field_count' | trans}}</label>
                    <input id="maxFieldCount_mastering"
                                   ref="maxFieldCount_mastering"
                                   :label="'protocol.max_field_count' | trans"
                                   type="number"
                                   v-on:keydown="changeNumberMax($event, 1)"
                                   v-on:change="changeMaxFieldCount(masteringMaxFieldCount,1)"
                                   min=1
                                   max=15
                                   name="maxFieldCount_mastering"
                                   :class="{'is-invalid': errors.has('maxFieldCount_mastering')}"
                                   v-validate="'min_value:'+masteringMinFieldCount+'|max_value:15|numeric'"
                                   v-model.number="masteringMaxFieldCount"
                                   data-vv-validate-on="none"
                                   :data-vv-as="'validation.attributes.protocol.max_field_count' | trans"/>
                    <span class="invalid-feedback"
                          v-if="errors.has('maxFieldCount_mastering')">
                                <strong>{{ errors.first('maxFieldCount_mastering') }}</strong>
                            </span>
                  </div>
                </div>
              </div>

              <div class="col-md-12" v-if="masteringActive">
                <div class="row">

                  <div class="col-md-12 choose-block mt-4">
                    <p class="sub-title">{{'protocol.condition_tranfer' |
                      trans}}:</p>
                    <mdc-radio v-model="masteringTransferCondition"
                               name="transferCondition" :value="transferConditionValue.first"
                               :checked="masteringTransferCondition == transferConditionValue.first">
                      {{'protocol.one_trial' | trans }}
                    </mdc-radio>
                    <mdc-radio v-model="masteringTransferCondition"
                               name="transferCondition"
                               :value="transferConditionValue.second" id="transferCondition2"
                               :checked="masteringTransferCondition == transferConditionValue.second">
                      <input id="trial_in_row"
                                     min=1
                                     ref="trial_in_row_mastering"
                                     type="number"
                                     v-on:keydown="changeNumber"
                                     name="trial_in_row"
                                     v-validate="'min_value:1|max_value:10|numeric'"
                                     v-model="masteringConditionTransfer.trialCount"
                                     data-vv-validate-on="none"
                                     :data-vv-as="'protocol.trial_in_row' | trans"/>
                      {{'protocol.trial_in_row' | trans }}
                    </mdc-radio>

                    <mdc-radio v-model="masteringTransferCondition"
                               name="transferCondition"
                               :value="transferConditionValue.third" id="transferCondition3"
                               :checked="masteringTransferCondition == transferConditionValue.third">
                      <input id="task_count"
                                     min=1
                                     ref="task_count_mastering"
                                     type="number"
                                     v-on:keydown="changeNumber"
                                     name="task_count"
                                     v-model=masteringConditionTransfer.sessionCount
                                     v-validate="'min_value:1|max_value:10|numeric'"
                                     data-vv-validate-on="none"
                                     :data-vv-as="'protocol.task_in_row' | trans"/>
                      {{'protocol.task_in_row' | trans }}
                    </mdc-radio>

                    <mdc-radio v-model="masteringTransferCondition"
                               name="transferCondition"
                               :value="transferConditionValue.fourth" id="transferCondition4"
                               :checked="masteringTransferCondition == transferConditionValue.fourth">
                      <input id="condition_procent_mastering"
                                     ref="condition_procent_mastering"
                                     min=80
                                     type="number"
                                     v-on:keydown="changeNumber"
                                     name="condition_procent_mastering"
                                     :class="{'is-invalid': errors.has('condition_procent_mastering')}"
                                     v-model=masteringConditionTransfer.ratio
                                     v-validate="'min_value:80|max_value:100|numeric'"
                                     data-vv-validate-on="none"
                                     :data-vv-as="'protocol.condition_procent' | trans"/>
                      {{'protocol.condition_procent' | trans }}
                      <input id="condition_session"
                                     min=1
                                     ref="condition_session_mastering"
                                     class="ml-2"
                                     type="number"
                                     v-on:keydown="changeNumber"
                                     name="condition_session"
                                     v-model=masteringConditionTransfer.conditionSession
                                     v-validate="'min_value:1|max_value:10|numeric'"
                                     data-vv-validate-on="none"
                                     :data-vv-as="'protocol.condition_trial' | trans"/>
                      {{'protocol.condition_trial' | trans }}

                      <input id="condition_trial"
                                     min=1
                                     ref="condition_trial_mastering"
                                     class="ml-2"
                                     type="number"
                                     v-on:keydown="changeNumber"
                                     name="condition_trial"
                                     v-model=masteringConditionTransfer.conditionTrial
                                     v-validate="'min_value:1|max_value:10|numeric'"
                                     data-vv-validate-on="none"
                                     :data-vv-as="'protocol.condition_session' | trans"/>

                      {{'protocol.condition_session' | trans }}
                    </mdc-radio>

                    <span class="invalid-feedback invalid"
                          v-if="errors.has('trial_in_row')">
                              <strong>{{errors.first('trial_in_row')}}  </strong>
                        </span>

                    <span class="invalid-feedback invalid"
                          v-if="errors.has('task_count')">
                              <strong>{{errors.first('task_count')}} </strong>
                        </span>
                    <span class="invalid-feedback invalid"
                          v-if="errors.has('condition_procent_mastering')">
                              <strong>{{errors.first('condition_procent_mastering')}} </strong>
                        </span>
                    <span class="invalid-feedback invalid"
                          v-if="errors.has('condition_trial')">
                              <strong>{{errors.first('condition_trial')}} </strong>
                        </span>
                    <span class="invalid-feedback invalid"
                          v-if="errors.has('condition_session')">
                              <strong>{{errors.first('condition_session')}} </strong>
                        </span>


                  </div>
                </div>
              </div>


              <div class="col-md-12" v-if="masteringActive && masteringTaskType">
                <div class="row" v-if="masteringTaskType.id != 1">
                  <div class="col-12">
                    <mdc-switch v-model="masteringVisible">
                      {{'protocol.track_change_level' | trans}}
                    </mdc-switch>
                  </div>
                  <hints :hint-list="hintListMastering" :hintVisible="masteringVisible"/>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="col-md-12 mt-3">

          <div class="box-shadow"  v-if="protocol.stages[currentStageIndex]">
            <div class="row">

              <div class="col-12"><h4 class="row-title">
                {{'protocol.setup_rotation' | trans}}: <mdc-switch v-model="rotationActive"/>
                <mdc-checkbox v-if="rotationActive" v-model="rotation.withFields" class="float-right" :label="'protocol.withFields' | trans"/>
              </h4></div>

              <div class="col-12" v-if="rotationActive">
                <div class="row">
                  <div class="col-md-4 required">

                    <v-select name="taskTypeRotation"
                              id="taskTypeRotation"
                              ref="taskTypeRotation"
                              :options="taskTypesList"
                              label="title"
                              :class="{'is-clear': !rotationTaskType, 'is-invalid': errors.has('taskTypeRotation')}"
                              v-validate="'required'"
                              data-vv-validate-on="none"
                              v-model=rotationTaskType
                              :data-vv-as="'protocol.task_type' | trans">
                      <template slot="no-options">
                        <div @mousedown.stop="">
                          {{ 'protocol.no_data' | trans }}
                        </div>
                      </template>
                    </v-select>
                    <label class="mdc-floating-label" :class="{'is-invalid': errors.has('taskTypeRotation')}">{{'protocol.task_type' |
                      trans}} <sup><mdc-icon class="help_icon" icon="help"  v-tooltip.top-center="msg"></mdc-icon></sup></label>
                    <span class="invalid-feedback"
                          v-if="errors.has('taskTypeRotation')">
                                    <strong>{{ errors.first('taskTypeRotation') }}</strong>
                                </span>
                  </div>

                  <div class="col-md-4" v-if="rotation.withFields">
                    <label class="mdc-label">{{'protocol.min_field_count' | trans}}</label>
                    <input id="minFieldCount_rotation"
                                   min=1
                                   max=15
                                   ref="minFieldCount_rotation"
                                   :label="'protocol.min_field_count' | trans"
                                   type="number"
                                   v-on:keydown="changeNumberMax($event, 2)"
                                   v-on:change="changeMinFieldCount(rotationMinFieldCount,2)"
                                   name="minFieldCount_rotation"
                                   :class="{'is-invalid': errors.has('minFieldCount_rotation')}"
                                   v-validate="'min_value:1|max_value:15|numeric'"
                                   v-model.number=rotationMinFieldCount
                                   data-vv-validate-on="none"
                                   :data-vv-as="'validation.attributes.protocol.min_field_count' | trans"/>
                    <span class="invalid-feedback"
                          v-if="errors.has('minFieldCount_rotation')">
                                    <strong>{{ errors.first('minFieldCount_rotation') }}</strong>
                                </span>
                  </div>

                  <div class="col-md-4" v-if="rotation.withFields">
                    <label class="mdc-label">{{'protocol.max_field_count' | trans}}</label>
                    <input id="maxFieldCount_rotation"
                                   min=1
                                   max=15
                                   ref="maxFieldCount_rotation"
                                   :label="'protocol.max_field_count' | trans"
                                    type="number"
                                   v-on:keydown="changeNumberMax($event, 2)"
                                   v-on:change="changeMaxFieldCount(rotationMaxFieldCount,2)"
                                   name="maxFieldCount_rotation"
                                   :class="{'is-invalid': errors.has('maxFieldCount_rotation')}"
                                   v-validate="'min_value:'+rotationMinFieldCount+'|max_value:15|numeric'"
                                   v-model.number=rotationMaxFieldCount
                                   data-vv-validate-on="none"
                                   :data-vv-as="'validation.attributes.protocol.max_field_count' | trans"/>
                    <span class="invalid-feedback"
                          v-if="errors.has('maxFieldCount_rotation')">
                                    <strong>{{ errors.first('maxFieldCount_rotation') }}</strong>
                                </span>
                  </div>
                </div>
              </div>

              <div class="col-md-12" v-if="rotationActive">
                <div class="row">

                  <div class="col-md-12 choose-block mt-4">
                    <p class="sub-title">{{'protocol.condition_tranfer' |
                      trans}}:</p>
                    <mdc-radio v-model="rotationTransferCondition"
                               name="transferConditionRotation" :value="transferConditionValue.first"
                               :checked="rotationTransferCondition == transferConditionValue.first">
                      {{'protocol.one_trial' | trans }}
                    </mdc-radio>
                    <mdc-radio v-model="rotationTransferCondition"
                               name="transferConditionRotation"
                               :value="transferConditionValue.second" id="transferCondition2"
                               :checked="rotationTransferCondition == transferConditionValue.second">
                      <input id="trial_count"
                                     min=1
                                     type="number"
                                     v-on:keydown="changeNumber"
                                     name="trial_count_rotation"
                                     v-model=rotationConditionTransfer.trialCount
                                     v-validate="'min_value:1|max_value:10|numeric'"
                                     data-vv-validate-on="none"
                                     :data-vv-as="'protocol.trial_in_row' | trans"/>
                      {{'protocol.trial_in_row' | trans }}
                    </mdc-radio>

                    <mdc-radio v-model="rotationTransferCondition"
                               name="transferConditionRotation"
                               :value="transferConditionValue.third" id="transferCondition3"
                               :checked="rotationTransferCondition == transferConditionValue.third">
                      <input id="task_count_rotation"
                                     ref="task_count_rotation"
                                     min=1
                                     type="number"
                                     v-on:keydown="changeNumber"
                                     name="task_count_rotation"
                                     v-model=rotationConditionTransfer.sessionCount
                                     v-validate="'min_value:1|max_value:10'"
                                     data-vv-validate-on="none"
                                     :data-vv-as="'protocol.task_in_row' | trans"/>
                      {{'protocol.task_in_row' | trans }}
                    </mdc-radio>

                    <mdc-radio v-model="rotationTransferCondition"
                               name="transferConditionRotation"
                               :value="transferConditionValue.fourth" id="transferCondition4"
                               :checked="rotationTransferCondition == transferConditionValue.fourth">
                      <input id="condition_procent_rotation"
                                     ref="condition_procent_rotation"
                                     min=80
                                     type="number"
                                     v-on:keydown="changeNumber"
                                     name="condition_procent_rotation"
                                     :class="{'is-invalid': errors.has('condition_procent_rotation')}"
                                     v-model=rotationConditionTransfer.ratio
                                     v-validate="'min_value:80|max_value:100|numeric'"
                                     data-vv-validate-on="none"
                                     :data-vv-as="'protocol.condition_procent' | trans"/>
                      {{'protocol.condition_procent' | trans }}
                      <input id="condition_session_rotation"
                                     ref="condition_session_rotation"
                                     min=1
                                     class="ml-2"
                                     type="number"
                                     v-on:keydown="changeNumber"
                                     name="condition_session_rotation"
                                     v-model=rotationConditionTransfer.conditionSession
                                     v-validate="'min_value:1|max_value:10|numeric'"
                                     data-vv-validate-on="none"
                                     :data-vv-as="'protocol.condition_trial' | trans"/>
                      {{'protocol.condition_trial' | trans }}

                      <input id="condition_trial_rotation"
                                     ref="condition_trial_rotation"
                                     min=1
                                     class="ml-2"
                                     type="number"
                                     v-on:keydown="changeNumber"
                                     name="condition_trial_rotation"
                                     v-model=rotationConditionTransfer.conditionTrial
                                     v-validate="'min_value:1|max_value:10|numeric'"
                                     data-vv-validate-on="none"
                                     :data-vv-as="'protocol.condition_session' | trans"/>

                      {{'protocol.condition_session' | trans }}
                    </mdc-radio>

                    <span class="invalid-feedback invalid"
                          v-if="errors.has('trial_count_rotation')">
                              <strong>{{errors.first('trial_count_rotation')}}  </strong>
                        </span>
                    <span class="invalid-feedback invalid"
                          v-if="errors.has('task_count_rotation') ">
                              <strong>{{errors.first('task_count_rotation')}} </strong>
                        </span>
                    <span class="invalid-feedback invalid"
                          v-if="errors.has('condition_procent_rotation') ">
                              <strong>{{errors.first('condition_procent_rotation')}} </strong>
                        </span>
                    <span class="invalid-feedback invalid"
                          v-if="errors.has('condition_trial_rotation')">
                              <strong>{{errors.first('condition_trial_rotation')}} </strong>
                        </span>
                    <span class="invalid-feedback invalid"
                          v-if="errors.has('condition_session_rotation')">
                              <strong>{{errors.first('condition_session_rotation')}} </strong>
                        </span>

                  </div>
                </div>
              </div>
              <div class="col-md-12" v-if="rotationActive && rotationTaskType">
                <div class="row"  v-if="rotationTaskType.id != 1">
                  <div class="col-12">
                    <mdc-switch v-model="rotationVisible">
                      {{'protocol.track_change_level' | trans}}
                    </mdc-switch>
                  </div>
                  <hints :hint-list="hintListRotation" :hintVisible="rotationVisible"/>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="col-md-12 mt-3">

          <div class="box-shadow"  v-if="protocol.stages[currentStageIndex]">
            <div class="row">

              <div class="col-12"><h4 class="row-title">
                {{'protocol.setup_fluency' | trans}}: <mdc-switch v-model="fluencyActive"/>

                <mdc-checkbox v-if="fluencyActive" v-model="fluency.withFields" class="float-right" :label="'protocol.withFields' | trans"/>
              </h4></div>

              <div class="col-12" v-if="fluencyActive">
                <div class="row">
                  <div class="col-md-4  required">
                    <label class="mdc-label">{{'protocol.executionSecondsLimit' | trans}}</label>
                    <input id="executionSecondsLimit"
                                   min=3
                                   ref="executionSecondsLimit"
                                   :label="'protocol.executionSecondsLimit' | trans"
                                   type="number"
                                   v-on:keydown="changeNumber"
                                   name="executionSecondsLimit"
                                   :class="{'is-invalid': errors.has('executionSecondsLimit')}"
                                   v-validate="'min_value:3|required|numeric'"
                                   v-model=fluency.executionSecondsLimit
                                   data-vv-validate-on="none"
                                   :data-vv-as="'protocol.executionSecondsLimit' | trans"/>
                    <span class="invalid-feedback"
                          v-if="errors.has('executionSecondsLimit')">
                                    <strong>{{ errors.first('executionSecondsLimit') }}</strong>
                                </span>
                  </div>

                  <div class="col-md-4" v-if="fluency.withFields">
                    <label class="mdc-label">{{'protocol.min_field_count' | trans}}</label>
                    <input id="minFieldCount_fluency"
                                   min=1
                                   max=15
                                   ref="minFieldCount_fluency"
                                   :label="'protocol.min_field_count' | trans"
                                   type="number"
                                   v-on:keydown="changeNumberMax($event, 4)"
                                   v-on:change="changeMinFieldCount(fluencyMinFieldCount,4)"
                                   name="minFieldCount_fluency"
                                   :class="{'is-invalid': errors.has('minFieldCount_fluency')}"
                                   v-validate="'min_value:1|max_value:15|numeric'"
                                   v-model.number=fluencyMinFieldCount
                                   data-vv-validate-on="none"
                                   :data-vv-as="'validation.attributes.protocol.min_field_count' | trans"/>
                    <span class="invalid-feedback"
                          v-if="errors.has('minFieldCount_fluency')">
                                    <strong>{{ errors.first('minFieldCount_fluency') }}</strong>
                                </span>
                  </div>

                  <div class="col-md-4" v-if="fluency.withFields">
                    <label class="mdc-label">{{'protocol.max_field_count' | trans}}</label>
                    <input id="maxFieldCount_fluency"
                                   min=1
                                   max=15
                                   ref="maxFieldCount_fluency"
                                   :label="'protocol.max_field_count' | trans"
                                   type="number"
                                   v-on:keydown="changeNumberMax($event, 4)"
                                   v-on:change="changeMaxFieldCount(fluencyMaxFieldCount,4)"
                                   name="maxFieldCount_fluency"
                                   :class="{'is-invalid': errors.has('maxFieldCount_fluency')}"
                                   v-validate="'min_value:'+fluencyMinFieldCount+'|max_value:15|numeric'"
                                   v-model.number=fluencyMaxFieldCount
                                   data-vv-validate-on="none"
                                   :data-vv-as="'validation.attributes.protocol.max_field_count' | trans"/>
                    <span class="invalid-feedback"
                          v-if="errors.has('maxFieldCount_fluency')">
                       <strong>{{ errors.first('maxFieldCount_fluency') }}</strong>
                    </span>
                  </div>


                </div>
              </div>


              <div class="col-md-12" v-if="fluencyActive">
                <div class="row">

                  <div class="col-md-12 choose-block mt-4">
                    <p class="sub-title">{{'protocol.condition_tranfer' |
                      trans}}:</p>
                    <mdc-radio v-model="fluencyTransferCondition"
                               name="transferConditionFluency" :value="transferConditionValue.first"
                               :checked="fluencyTransferCondition == transferConditionValue.first">
                      {{'protocol.one_trial' | trans }}
                    </mdc-radio>
                    <mdc-radio v-model="fluencyTransferCondition"
                               name="transferConditionFluency"
                               :value="transferConditionValue.second" id="transferCondition2"
                               :checked="fluencyTransferCondition == transferConditionValue.second">
                      <input id="trial_count"
                                     min=1
                                     type="number"
                                     v-on:keydown="changeNumber"
                                     name="trial_count_fluency"
                                     v-model=fluencyConditionTransfer.trialCount
                                     v-validate="'min_value:1|max_value:10|numeric'"
                                     data-vv-validate-on="none"
                                     :data-vv-as="'protocol.trial_in_row' | trans"/>
                      {{'protocol.trial_in_row' | trans }}
                    </mdc-radio>

                    <mdc-radio v-model="fluencyTransferCondition"
                               name="transferConditionFluency"
                               :value="transferConditionValue.third" id="transferCondition3"
                               :checked="fluencyTransferCondition == transferConditionValue.third">
                      <input id="task_count_fluency"
                                     ref="task_count_fluency"
                                     min=1
                                     type="number"
                                     v-on:keydown="changeNumber"
                                     name="task_count_fluency"
                                     v-model=fluencyConditionTransfer.sessionCount
                                     v-validate="'min_value:1|max_value:10|numeric'"
                                     data-vv-validate-on="none"
                                     :data-vv-as="'protocol.task_in_row' | trans"/>
                      {{'protocol.task_in_row' | trans }}
                    </mdc-radio>

                    <mdc-radio v-model="fluencyTransferCondition"
                               name="transferConditionFluency"
                               :value="transferConditionValue.fourth" id="transferCondition4"
                               :checked="fluencyTransferCondition == transferConditionValue.fourth">
                      <input id="condition_procent_fluency"
                                     ref="condition_procent_fluency"
                                     min=80
                                     type="number"
                                     v-on:keydown="changeNumber"
                                     name="condition_procent_fluency"
                                     :class="{'is-invalid': errors.has('condition_procent_fluency')}"
                                     v-model=fluencyConditionTransfer.ratio
                                     v-validate="'min_value:80|max_value:100|numeric'"
                                     data-vv-validate-on="none"
                                     :data-vv-as="'protocol.condition_procent' | trans"/>
                      {{'protocol.condition_procent' | trans }}

                      <input id="condition_session_fluency"
                                     ref="condition_session_fluency"
                                     min=1
                                     class="ml-2"
                                     type="number"
                                     v-on:keydown="changeNumber"
                                     name="condition_session_fluency"
                                     v-model=fluencyConditionTransfer.conditionSession
                                     v-validate="'min_value:1|max_value:10|numeric'"
                                     data-vv-validate-on="none"
                                     :data-vv-as="'protocol.condition_trial' | trans"/>
                      {{'protocol.condition_trial' | trans }}
                      <input id="condition_trial_fluency"
                                     ref="condition_trial_fluency"
                                     min=1
                                     class="ml-2"
                                     type="number"
                                     v-on:keydown="changeNumber"
                                     name="condition_trial_fluency"
                                     v-model=fluencyConditionTransfer.conditionTrial
                                     v-validate="'min_value:1|max_value:10|numeric'"
                                     data-vv-validate-on="none"
                                     :data-vv-as="'protocol.condition_session' | trans"/>
                      {{'protocol.condition_session' | trans }}
                    </mdc-radio>

                    <span class="invalid-feedback invalid"
                          v-if="errors.has('trial_count_fluency')">
                              <strong>{{errors.first('trial_count_fluency')}}  </strong>
                        </span>
                    <span class="invalid-feedback invalid"
                          v-if="errors.has('task_count_fluency') ">
                              <strong>{{errors.first('task_count_fluency')}} </strong>
                        </span>
                    <span class="invalid-feedback invalid"
                          v-if="errors.has('condition_procent_fluency') ">
                              <strong>{{errors.first('condition_procent_fluency')}} </strong>
                        </span>
                    <span class="invalid-feedback invalid"
                          v-if="errors.has('condition_trial_fluency')">
                              <strong>{{errors.first('condition_trial_fluency')}} </strong>
                        </span>
                    <span class="invalid-feedback invalid"
                          v-if="errors.has('condition_session_fluency')">
                              <strong>{{errors.first('condition_session_fluency')}} </strong>
                        </span>

                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>


        <div class="col-md-12 mt-3">
          <div class="box-shadow"  v-if="protocol.stages[currentStageIndex]">
            <div class="row">
              <div class="col-12">
                <h4 class="row-title">
                  {{'protocol.setup_support' | trans}} : <mdc-switch v-model="intervalsActive"/>
                </h4>
                <p class="gray-dark">{{'protocol.stimulus_intervals' |
                  trans}}</p>
                <p v-if="protocol.assigneeId">{{'protocol.support_subtitle' | trans}}</p>
                <span class="invalid-feedback invalid"
                      v-if="intervalError">
                              <strong>{{'protocol.interval_error' | trans}}</strong>
                        </span>

                <table class="table table-sm" v-if="intervalsActive">
                  <thead class="thead-light">
                  <tr>
                    <th>{{'protocol.interval_name' | trans}}</th>
                    <th class="table-count">{{'protocol.interval_count' | trans}}</th>
                    <th class="table-actions"></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="interval in intervals" :key="interval.index">
                    <td>
                      {{interval.name}}
                    </td>
                    <td class="table-count">
                      <input type="number"
                                     v-on:keydown="changeNumber"
                                     min=1
                                     name="interval_count"
                                     v-model="interval.count"
                                     data-vv-validate-on="none"
                                     v-validate="'min_value:1|numeric'"
                                     :data-vv-as="'protocol.interval_count' | trans"/>
                    </td>
                    <td>
                      <mdc-checkbox v-model="interval.checked"/>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <span class="invalid-feedback invalid"
                      v-if="errors.has('interval_count')">
                        <strong>{{ errors.first('interval_count') }}</strong>
                    </span>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-12">
          <button type="submit"
                  class="btn btn-primary mr-2"
                  @click.prevent="hideTasks(true)">
            {{'protocol.buttons.back_to_protocol' | trans}}
          </button>
        </div>
      </div>



    <div v-if="isModalVisible">
      <task-d-t-t-modal :visible="isModalVisible"
        :stimul="stimul"
        :intervals="intervals"
        :data="currentStage.phases"
        v-on:close="onModalClose"
        v-on:save="onModalSave"/>
    </div>

    <div v-if="isModalChangePhaseVisible">
      <task-dtt-phase-modal :visible="isModalChangePhaseVisible"
                        :stimulList="stimulListToChange"
                        :intervals="intervals"
                        :data="currentStage.phases"
                        v-on:close="onModalClose"
                        v-on:save="onModalSaveChanges"/>
    </div>

    <div v-if="modalView">
      <mdc-dialog v-model="modalView"
                  :title="'protocol.OffPhaseModalTitle', {phaseName: phaseName} | trans"
                  :accept="'protocol.offButton' | trans"
                  :cancel="'user.cancel' | trans"
                  @accept="onModalSavePhase"
                  @cancel="onModalClosePhase">

      </mdc-dialog>
    </div>

    <div v-if="modalViewField">
      <mdc-dialog v-model="modalViewField"
                  :title="'protocol.moveFieldTitle', {min: minValue, max: maxValue} | trans"
                  :accept="'behavior.buttons.apply' | trans"
                  :cancel="'user.cancel' | trans"
                  @accept="onModalSaveField"
                  @cancel="onModalCloseField">

      </mdc-dialog>
    </div>

  </div>

</template>

<script>
  import lang from '../../../lang/translator';
  import findIndex from 'lodash/findIndex';
  import isUndefined from 'lodash/isUndefined';
  import isString from 'lodash/isString';
  import forEach from 'lodash/forEach';
  import isNull from 'lodash/isNull';
  import isEmpty from 'lodash/isEmpty';
  import includes from 'lodash/includes';
  import {Validator} from 'vee-validate';
  import forIn from 'lodash/forIn';
  import ConfirmModal from './ConfirmModal';
  import TaskDTTModal from './TaskDTTModal';
  import TaskDttPhaseModal from './TaskDttPhaseModal';
  import cloneDeep from 'lodash/cloneDeep';
  import filter from 'lodash/filter';
  import isInteger from 'lodash/isInteger';
  import parseInt from 'lodash/parseInt';
  import sortBy from 'lodash/sortBy';
  import {TRANSFER_CONDITION} from '../../protocols/constants.js';
  import draggable from 'vuedraggable';
  import Hints from '../../protocols/components/Hints';
  import UuidGenerator from '@/common/uuid/UuidGenerator';
  import trim from 'lodash/trim';
  import toInteger from 'lodash/toInteger';
  import map from 'lodash/map';
  import {mapGetters, mapActions, mapState} from 'vuex';

  export default {
    components: {ConfirmModal, draggable, TaskDTTModal, TaskDttPhaseModal, Hints},
    props: [
      'protocol',
      'isNew',
      'taskTypes',
      'selectedTaskTypeTitle',
      'selectedStagesTitle',
      'changeFromClient',
      'showDeleteButton',
      'transferConditionValue'],
    data() {
      return {
        apiUrl: '/protocols/',
        disabled: false,
        currentStageIndex: 0,
        currentStageTitle: '',
        currentStage: {},
        selectedStage: {},
        tasks: [],
        addStimulusItem: null,
        selected: {},
        taskType: {},
        taskTypesList: [],
        tempCurrentStageAttemptCount: null,
        coldSampleIds: [1, 5],
        baseColdSample: 5,
        spoTaskTypes: [],
        disabledChange: false,
        errorPhaseCount: false,
        stimulList: [],
        isModalVisible: false,
        modal: null,
        stimul: null,
        isStimulVisible: false,
        dragging: false,
        masteringConditionTransfer:{
          trialCount: '2',
          sessionCount: '2',
          ratio: '80',
          conditionTrial: '3',
          conditionSession: '3',
        },
        rotationConditionTransfer:{
          trialCount: '2',
          sessionCount: '2',
          ratio: '80',
          conditionTrial: '3',
          conditionSession: '3',
        },
        fluencyConditionTransfer:{
          trialCount: '2',
          sessionCount: '2',
          ratio: '80',
          conditionTrial: '3',
          conditionSession: '3',
        },
        masteringTransferCondition: null,
        rotationTransferCondition: null,
        fluencyTransferCondition: null,
        masteringMinFieldCount: null,
        rotationMinFieldCount: null,
        fluencyMinFieldCount: null,
        masteringMaxFieldCount: null,
        rotationMaxFieldCount: null,
        fluencyMaxFieldCount: null,
        masteringTaskType: null,
        rotationTaskType: null,
        mastering: null,
        masteringActive: true,
        rotationActive: true,
        intervalsActive: true,
        fluencyActive: true,
        supportActive: true,
        rotation: null,
        intervalsList: null,
        fluency: null,
        interval_count: null,
        modalView:false,
        phaseName: null,
        afterLoad: false,
        intervals: [
          {typeId: 1, name: lang.get('protocol.through_each_lesson'), count: '3', checked: false},
          {typeId: 2, name: lang.get('protocol.after_one_lesson'), count: '3', checked: false},
          {typeId: 3, name: lang.get('protocol.after_two_classes'), count: '3', checked: false},
          {typeId: 4, name: lang.get('protocol.after_three_classes'), count: '3', checked: false},
          {typeId: 5, name: lang.get('protocol.once_a_week'), count: '3', checked: false},
          {typeId: 6, name: lang.get('protocol.once_every_two_weeks'), count: '3', checked: false},
          {typeId: 7, name: lang.get('protocol.once_a_month'), count: '3', checked: false},
        ],
        intervalError: false,
        options: {
          filterable: false,
          sortable: [],
          skin: 'table table-sm',
          headings: {
            name: lang.get('protocol.interval_name'),
            count: lang.get('protocol.interval_count'),
            action: '',
          },
          texts: {
            noResults: lang.get('protocol.no_data'),
            loading: lang.get('home.labels.loading_message_table'),
          },
          columnsClasses:{
            count:'table-count',
            action:'table-actions',
          },
        },
        currentPhaseType: null,
        phaseType: null,
        modalViewField: false,
        minValue: null,
        maxValue: null,
        oldMinValue: null,
        oldMaxValue: null,
        hintListMastering: null,
        hintListRotation: null,
        masteringVisible: false,
        rotationVisible: false,
        oldValueMax: null,
        oldValueMin: null,
        changedValue: false,
        intervalId: null,
        msg: lang.get('protocol.enable_recording'),
        stimulListToChange: null,
        isModalChangePhaseVisible: false
      };
    },
    computed: {
      isEmptySelectedStage: function() {
        return isEmpty(this.selectedStage);
      },
      isEditing(){
        let active = filter(this.currentStage.phases, function(item) { return item.active });
        return !((active.length == 1 && ((active[0].typeId == 3 && active[0].intervals.length == 1) || (active[0].typeId != 3 && !active[0].withFields))) || active.length == 0);
      },
      taskTypesNew() {
        return this.taskTypes.filter((item) => {
          return item.title !== this.taskType.title;
        });
      },
      spoTaskTypesNew() {
        return this.spoTaskTypes.filter((item) => {
          return item.title !== this.spoTaskTypes.title;
        });
      },
      protocolStages() {
        return this.protocol.stages.filter((item) => {
          return item.title !== this.currentStage.title;
        });
      },

      currentStageAttemptCount: {
        get: function() {
          if (this.tempCurrentStageAttemptCount) {
            if (isString(this.tempCurrentStageAttemptCount)) {
              return this.tempCurrentStageAttemptCount;
            }
            else {
              return this.tempCurrentStageAttemptCount.toString();
            }
          }
        },
        set: function(newValue) {
          if (this.tempCurrentStageAttemptCount !== newValue) {
            this.tempCurrentStageAttemptCount = newValue;
            if (this.isBaseColdSample) {
              this.currentStage.attemptCount = newValue;
              this.currentStage.generate.attempts = newValue;
            } else {
              this.currentStage.attemptCount = newValue;
            }
          }
        },
      },
      isBaseColdSample: {
        get: function() {
          return this.baseColdSample === this.taskType.id;
        },
      },

      stimulListToChangeAndActive(){
        return filter(this.tasks, (task) => {
          return task.changed && task.active;
        }).length;
      },

      ...mapGetters('mobile', [
        'isMobile',
      ]),
    },

    mounted: function() {
      this.$nextTick(function() {
        this.intervalId = window.setInterval(() => {
          this.hideTasks();
        }, 5000);

      });
    },

    beforeDestroy() {
      clearInterval(this.intervalId)
    },

    methods: {

      acivatedTask(task){
        if (task.active){
          let taskCurrent =  filter(this.tasks, function(item) {
            return item.globalUuid == task.globalUuid;
          })[0];

          this.$set(taskCurrent, 'phaseType', filter(this.currentStage.phases, (item) =>{ return item.active; })[0].typeId);
          this.$set(taskCurrent, 'fieldIndex', taskCurrent.phaseType != 3 ? filter(this.currentStage.phases, (item) =>{ return item.active; })[0].minFieldCount : null);
          this.$set(taskCurrent, 'intervalType', taskCurrent.phaseType == 3 ? filter(this.intervals, (interval) => {return interval.checked;})[0] : null);


        }
      },

      changeNumber(event){
        if (event.shiftKey || !((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105) || event.keyCode == 46 || event.keyCode == 8|| (event.keyCode >= 35 && event.keyCode <= 40) )) {
          event.preventDefault();
        }
      },

      changeMaxMinValue(typeId){
        let oldMax = null;
        let oldMin = null;
        if(typeId == 1){
          oldMax = this.masteringMaxFieldCount;
          oldMin = this.masteringMinFieldCount;
        }

        if (typeId == 2){
          oldMax = this.rotationMaxFieldCount;
          oldMin = this.rotationMinFieldCount;
        }

        if (typeId == 4){
          oldMax = this.fluencyMaxFieldCount;
          oldMin = this.fluencyMinFieldCount;
        }
        this.oldValueMax = toInteger(oldMax);
        this.oldValueMin = toInteger(oldMin);
        this.changedValue = true;

      },

      changeNumberMax(event, typeId){
        if (!((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105) || event.keyCode == 46 || event.keyCode == 8|| (event.keyCode >= 35 && event.keyCode <= 40) )) {
          event.preventDefault();
        } else{
          if(!this.changedValue){
            this.changeMaxMinValue(typeId);
          }
        }
      },

      changeMaxFieldCount(max, typeId){

        if (this.afterLoad && max > 0) {

          let phase = filter(this.currentStage.phases, function(item) {
            return item.typeId == typeId;
          })[0];

          let minValue = null;

          if(!this.oldValueMin){
            this.changeMaxMinValue(typeId);
          }

          if (this.oldValueMin && (toInteger(this.oldValueMin) > toInteger(max))) {
            if(typeId == 1){
              this.masteringMinFieldCount = max;
            }
            if (typeId == 2){
              this.rotationMinFieldCount = max;
            }
            if (typeId == 4){
              this.fluencyMinFieldCount = max;
            }
            minValue = max;
          } else{
            if(typeId == 1){
              minValue = this.masteringMinFieldCount;
            }
            if (typeId == 2){
              minValue = this.rotationMinFieldCount;
            }
            if (typeId == 4){
              minValue = this.fluencyMinFieldCount;
            }
          }

          let newTask  = filter(this.tasks, task => {
            return task.phaseType == typeId && toInteger(task.fieldIndex) > toInteger(max);
          })

          let taskCount = filter(this.tasks, task => {
            return task.phaseType == typeId && toInteger(task.fieldIndex) > toInteger(max);
          }).length;

          if (taskCount){
            this.modalViewField = true;
            this.maxValue = toInteger(max);
            this.minValue = toInteger(minValue);
            this.currentPhaseType = typeId;

          } else{
            phase.minFieldCount = toInteger(minValue);
            phase.maxFieldCount = toInteger(max);
          }

        }
        this.changedValue = false;
      },


      changeMinFieldCount(min, typeId){

        if (this.afterLoad && min > 0) {

          let phase = filter(this.currentStage.phases, function(item) {
            return item.typeId == typeId;
          })[0];

          let maxValue = null;

          if(!this.oldValueMax){
            this.changeMaxMinValue(typeId);
          }

          if (toInteger(this.oldValueMax) < toInteger(min)) {
            if(typeId == 1){
              this.masteringMaxFieldCount = min;
            }
            if (typeId == 2){
              this.rotationMaxFieldCount = min;
            }
            if (typeId == 4){
              this.fluencyMaxFieldCount = min;
            }
            maxValue = min;

          } else{
            if(typeId == 1){
              maxValue = this.masteringMaxFieldCount;
            }
            if (typeId == 2){
              maxValue = this.rotationMaxFieldCount;
            }
            if (typeId == 4){
              maxValue = this.fluencyMaxFieldCount;
            }
          }

          let taskCount = filter(this.tasks, task => {
            return task.phaseType == typeId && toInteger(task.fieldIndex) < toInteger(min);
          }).length;

          if (taskCount){
            this.modalViewField = true;
            this.minValue = toInteger(min);
            this.maxValue = toInteger(maxValue);
            this.currentPhaseType = typeId;

          } else{
            phase.minFieldCount = toInteger(min);
            phase.maxFieldCount = toInteger(maxValue);
          }

        }
        this.changedValue = false;
      },

      currentIntervalType(typeId) {
        let currentInterval = null;
        if(typeId){
          currentInterval = filter(this.intervals, (interval) => {
            return interval.typeId == typeId;
          })[0];
        } else{
          currentInterval = filter(this.intervals, (interval) => {
            return interval.checked;
          })[0];
        }
        let currentIntervalName = currentInterval ? currentInterval.name : null;
        return currentIntervalName;
      },

      onEditBtnClick (item) {
        this.stimul = item
        this.isModalVisible = true
      },

      onModalClose () {
        this.isModalVisible = false;
        this.isModalChangePhaseVisible = false;
      },

      onModalSave(phaseTask, field, interval){
        let currentTask = filter(this.tasks, (task) => {
          return task.description === this.stimul.description;
        })[0];

        currentTask.phaseType = phaseTask;
        currentTask.phaseId = phaseTask.id;
        currentTask.fieldIndex = phaseTask != 3 ? field : null;
        currentTask.intervalType = phaseTask == 3 && interval ? toInteger(interval.typeId) : null;

        this.isModalVisible = false;
      },

      onModalSaveChanges(phaseTask, field, interval){
        
        map(this.stimulListToChange, (task) => {

          task.phaseType = phaseTask;
          task.phaseId = phaseTask.id;
          task.fieldIndex = phaseTask  != 3 ? field : null;
          task.intervalType = phaseTask == 3 && interval ? toInteger(interval.typeId) : null;

          task.changed = false;
          return task;

        });


        this.isModalChangePhaseVisible = false;
      },


      onEditSomeBtnClick () {
        this.stimulListToChange = filter(this.tasks, (task) => {
          return task.changed && task.active;
        });

        if (this.stimulListToChange.length){
          this.isModalChangePhaseVisible = true;
        }
      },

      onModalSavePhase() {
        let phase = filter(this.currentStage.phases, (item) => { return item.typeId == this.currentPhaseType; })[0];
        phase.active = false;
      },

      onModalClosePhase(){
        let phase = filter(this.currentStage.phases, (item) => { return item.typeId == this.currentPhaseType; })[0];
        phase.active = true;
        if (this.currentPhaseType == 1){
          this.masteringActive = true;
        }
        if (this.currentPhaseType == 2){
          this.rotationActive = true;
        }

        if (this.currentPhaseType == 3){
          this.intervalsActive = true;
        }
        if (this.currentPhaseType == 4){
          this.fluencyActive = true;
        }
        this.modalView = false;
      },

      onModalSaveField() {
        let phase = filter(this.currentStage.phases, (item) => { return item.typeId == this.currentPhaseType; })[0];
        phase.minFieldCount = this.minValue;
        phase.maxFieldCount = this.maxValue;

        forEach(this.tasks, (task) => {
          if (task.phaseType == this.currentPhaseType && toInteger(task.fieldIndex) < toInteger(this.minValue)) {
            task.fieldIndex = this.minValue
          }

          if (task.phaseType == this.currentPhaseType && toInteger(task.fieldIndex) > toInteger(this.maxValue)) {
            task.fieldIndex = this.maxValue
          }
        });
        this.modalViewField = false;
        this.oldValueMax = null;
        this.oldValueMin = null;

      },

      onModalCloseField(){
        let phase = filter(this.currentStage.phases, (item) => { return item.typeId == this.currentPhaseType; })[0];
        phase.active = true;
        if (this.currentPhaseType == 1){
          this.masteringMinFieldCount = this.oldValueMin;
          this.masteringMaxFieldCount = this.oldValueMax;
        }
        if (this.currentPhaseType == 2){
          this.rotationMinFieldCount = this.oldValueMin;
          this.rotationMaxFieldCount = this.oldValueMax;
        }
        if (this.currentPhaseType == 4){
          this.fluencyMinFieldCount = this.oldValueMin;
          this.fluencyMaxFieldCount = this.oldValueMax;
        }
        this.modalViewField = false;
        this.oldValueMax = null;
        this.oldValueMin = null;
      },

      getCurrentStageIndex: function(title) {
        this.currentStageIndex = findIndex(this.protocol.stages, (stage) => {
          return stage.title === title;
        });

        return this.currentStageIndex;
      },

      async changeStages(data, canChange = false) {
        let current = this.currentStage;
        let result = await this.$validator.validateAll();
        if (!result && !canChange) {
          this.changeStages(current, true);
        }
        if (!isUndefined(data.tasks) && (Array.isArray(data.tasks))) {
          this.tasks = data.tasks;
        }
        this.currentStage = data;
        this.currentStageTitle = data.title;
        this.currentStageIndex = this.getCurrentStageIndex(data.title);
        this.currentStage.type = data.type;
        if (this.changeFromClient) {
          this.disabledChange = data.isNew ? false : true;
        }
        this.tempCurrentStageAttemptCount = this.currentStage.attemptCount;
      },

      addTask: function(addStimulusItem) {
        if (!addStimulusItem){
          return;
        }

        let unique = true;

        let stimulList = this.protocol.globalTasks;

        forIn(stimulList, function(stimul) {
          if (trim(stimul.description.toLowerCase()) ===
              trim(addStimulusItem.toLowerCase())) {
            unique = false;
          }
        });

        if (unique) {
          this.currentStage.isNew = true;

          let position = parseInt(this.tasks.length) + 1;
          let uuid = UuidGenerator.v4();

          this.tasks.unshift({
            'id': null,
            'stageId': null,
            'typeId': 1,
            'globalTaskId': null,
            'fieldIndex': filter(this.currentStage.phases, (item) =>{ return item.active; })[0].minFieldCount,
            'phaseType': filter(this.currentStage.phases, (item) =>{ return item.active; })[0].typeId,
            'position': position,
            'title': lang.get('protocol.stimulus') + ' ' + position,
            'description': addStimulusItem,
            'isNew': true,
            'active': true,
            'uuid': UuidGenerator.v4(),
            'globalUuid': uuid,
          });

          this.protocol.globalTasks.push({
            'id': null,
            'stageId': null,
            'typeId': 1,
            'fieldIndex': 1,
            'phaseType': 1,
            'position': position,
            'title': lang.get('protocol.stimulus') + ' ' + position,
            'description': addStimulusItem,
            'isNew': true,
            'active': false,
            'uuid': uuid
          });

          forIn(this.protocol.stages, (value, index) => {
            if (this.currentStageIndex != index && !value.isClosed){
              value.tasks.push({
                'id': null,
                'stageId': null,
                'typeId': 1,
                'phaseType': filter(value.phases, (item) =>{ return item.active; })[0].typeId,
                'globalTaskId': null,
                'fieldIndex': filter(value.phases, (item) =>{ return item.active; })[0].minFieldCount,
                'position': position,
                'title': lang.get('protocol.stimulus') + ' ' + position,
                'description': addStimulusItem,
                'isNew': true,
                'active': false,
                'uuid': UuidGenerator.v4(),
                'globalUuid': uuid,
              });
            }

          });

          this.addStimulusItem = null;
          this.changeCanPublish();

        } else {
          this.errors.add({
            field: 'addStimulusItem',
            msg: lang.get('rotation.unique_stimulus'),
          });
        }

      },

      editProtocol() {
        this.$emit('editProtocol');
      },

      createProtocol() {
        this.$emit('createProtocol');
      },

      changeCanPublish() {
        this.$emit('changeCanPublish');
      },

      protocolChanged() {
        this.$emit('protocolChanged');
      },

      reindexStages: function() {
        this.tasks.forEach(function(item, index) {
          let position = parseInt(index);
          item['position'] = parseInt(index);
        });
      },

      validatePhases: function() {
        let countActivePhase = filter(this.currentStage.phases, function(item) { return item.active; }).length;
        if (!this.masteringActive & !this.rotationActive & !this.intervalsActive & !this.fluencyActive){
          this.errorPhaseCount = true;
          setTimeout(() => {
            this.$refs.errorPhase.scrollIntoView();
          }, 100);
        } else{
          this.errorPhaseCount = false;

        }
         return countActivePhase;
      },


      async hideTasks(hide = false) {
        this.intervalError = false;
        this.disabled = true;
        let result = await this.$validator.validateAll();
        let valid = this.validatePhases();

        let protocol = this.protocol;
        protocol.stages[this.currentStageIndex] = this.currentStage;
        if (!result || !valid) {
          return;
        }

        let intervals = filter(protocol.stages[this.currentStageIndex].phases, function(item) { return item.typeId == 3; })[0];

        let intervalLenght = filter(this.intervals, function(val) { return val.checked; });
        if (!intervalLenght.length && this.intervalsActive) {
          this.intervalError = true;
          this.disabled = false;
          return;
        }

        intervals.intervals = filter(this.intervals, function(val) { return val.checked; });

        let mastering = filter(protocol.stages[this.currentStageIndex].phases,
            function(item) {
              return item.typeId == 1;
            })[0];
        let rotation = filter(protocol.stages[this.currentStageIndex].phases,
            function(item) {
              return item.typeId == 2;
            })[0];

        let fluency = filter(protocol.stages[this.currentStageIndex].phases,
            function(item) {
              return item.typeId == 4;
            })[0];

        mastering.taskType = this.masteringTaskType;
        rotation.taskType = this.rotationTaskType;
        fluency.taskType = filter(this.taskTypes,
            function(item) {
              return item.id == 1;
            })[0];

        mastering.transferCondition.id = this.masteringTransferCondition;
        rotation.transferCondition.id = this.rotationTransferCondition;
        fluency.transferCondition.id = this.fluencyTransferCondition;
        this.setTransferCondition(mastering.transferCondition,
            this.masteringConditionTransfer);
        this.setTransferCondition(rotation.transferCondition,
            this.rotationConditionTransfer);
        this.setTransferCondition(fluency.transferCondition,
            this.fluencyConditionTransfer);


        if (hide && this.hintListMastering[2].active || this.hintListMastering[3].active || this.hintListMastering[4].active || this.hintListMastering[5].active){
          this.hintListMastering[1].active = false;
        }

        if (hide && this.hintListRotation[2].active || this.hintListRotation[3].active || this.hintListRotation[4].active || this.hintListRotation[5].active){
          this.hintListRotation[1].active = false;
        }
        

        mastering.taskPrompts = this.hintListMastering;
        rotation.taskPrompts = this.hintListRotation;


        mastering.isPromptEnabled = this.masteringVisible;
        rotation.isPromptEnabled = this.rotationVisible;

        mastering.minFieldCount = toInteger(this.masteringMinFieldCount);
        rotation.minFieldCount = toInteger(this.rotationMinFieldCount);
        fluency.minFieldCount = toInteger(this.fluencyMinFieldCount);

        mastering.maxFieldCount = toInteger(this.masteringMaxFieldCount);
        rotation.maxFieldCount = toInteger(this.rotationMaxFieldCount);
        fluency.maxFieldCount = toInteger(this.fluencyMaxFieldCount);

        mastering.active = this.masteringActive;
        rotation.active = this.rotationActive;
        fluency.active = this.fluencyActive;
        intervals.active = this.intervalsActive

        protocol.stages[this.currentStageIndex].changed = true;

        protocol.stages[this.currentStageIndex].tasks = this.tasks;

        this.disabled = false;
        this.reindexStages();

        setTimeout(() => {
          this.protocol = protocol;
          if (hide){
            this.afterLoad = false;
            this.$emit('hideTasks');
          }
          this.protocolChanged();
        }, 100);
      },

      setStageGenerate: function() {
        if (!this.currentStage.hasOwnProperty('generate')) {
          this.currentStage['generate'] = {
            type: this.getSpoType(4),
            attempts: this.currentStage.attemptCount,
            answer: '-',
          };
        }

        if (isNull(this.currentStage.generate.type)) {
          this.currentStage.generate.type = this.getSpoType(4);
        }

        if (!isNull(this.currentStage.generate.attempts)) {
          this.currentStage.attemptCount = this.currentStage.generate.attempts;
        }
      },

      deleteStageGenerate: function() {
        if (this.currentStage.hasOwnProperty('generate')) {
          delete this.currentStage.generate;
        }
      },

      getSpoType: function(id) {
        let types = this.spoTaskTypes.filter(function(taskType) {
          return taskType.id === id;
        });

        return types.shift();
      },

      setTransferCondition(condition, conditionValue) {

        if (condition.id == TRANSFER_CONDITION.TRIAL_IN_A_ROW){
          condition['trialCount'] = conditionValue.trialCount;

        } else if (condition.id == TRANSFER_CONDITION.SESSION_IN_A_ROW){
          condition['sessionCount'] = conditionValue.sessionCount;

        } else if (condition.id == TRANSFER_CONDITION.RATIO){
          condition['ratio'] = conditionValue.ratio;
          condition['trialCount'] = conditionValue.conditionTrial;
          condition['sessionCount'] = conditionValue.conditionSession;
        }

      },

      getTransferCondition(condition, conditionValue) {

        if (conditionValue.id == TRANSFER_CONDITION.TRIAL_IN_A_ROW){
          condition.trialCount = conditionValue.trialCount;

        } else if (conditionValue.id == TRANSFER_CONDITION.SESSION_IN_A_ROW){
          condition.sessionCount = conditionValue.sessionCount;

        } else if (conditionValue.id == TRANSFER_CONDITION.RATIO){
          condition.ratio = conditionValue.ratio;
          condition.conditionTrial = conditionValue.trialCount;
          condition.conditionSession = conditionValue.sessionCount;
        }

      },

    },

    created() {
      if (this.selectedStagesTitle) {
        this.currentStageIndex = this.getCurrentStageIndex(
            this.selectedStagesTitle);
      }


      this.taskTypesList = filter(this.taskTypes, function(o) { return o.id == 1 || o.id == 4; });

      forEach(this.taskTypesList, (type) => {
        if (!(includes(this.coldSampleIds, type.id))) {
          this.spoTaskTypes.push(
              type,
          );
        }
      });

      this.currentStage = cloneDeep(this.protocol.stages[this.currentStageIndex]);
      this.currentStage.phases = sortBy(this.currentStage.phases, 'position');

      this.currentStageTitle = this.currentStage.title;
      if (this.currentStage.generate) {

      }
      this.taskType = this.currentStage.type;

      if (!this.taskTypesList) {
        let index = 0;
        if (this.selectedTaskTypeTitle) {
          index = findIndex(this.taskTypesList, (task) => {
            return task.title === this.selectedTaskTypeTitle;
          });
        }
        this.taskType = this.taskTypesList[index];
      }

      this.tasks = this.currentStage.tasks;


      forEach(this.tasks, (task) => {

        let phase = filter(this.currentStage.phases, function(item) { return item.typeId == task.typeId; })[0];


        if (phase && task.fieldIndex < phase.minFieldCount){
          task.fieldIndex = phase.withFields ? phase.minFieldCount : 1
        }

        //task.fieldIndex = phase.withFields ? phase.minFieldCount : 1
      });

      let intervals = filter(this.currentStage.phases, function(item) { return item.typeId == 3; })[0].intervals;

      if (intervals.length) {

          forEach(intervals, (item) => {
            let index = findIndex(this.intervals, {
              typeId: item.type ? item.type.id : item.typeId
            });

            this.intervals[index].id = item.id
            this.intervals[index].phaseId = item.phaseId
            this.intervals[index].count = item.count.toString()
            this.intervals[index].checked = true;
          });

      } else{
        this.intervals[0].checked = true;
      }

      this.mastering = filter(this.currentStage.phases, function(item) { return item.typeId == 1; })[0];
      this.mastering.title = lang.get('protocol.phase_mastering');
      this.rotation = filter(this.currentStage.phases, function(item) { return item.typeId == 2; })[0];
      this.rotation.title = lang.get('protocol.phase_rotation');
      this.fluency = filter(this.currentStage.phases, function(item) { return item.typeId == 4; })[0];
      this.fluency.title = lang.get('protocol.phase_fluency');
      this.intervalsList = filter(this.currentStage.phases, function(item) { return item.typeId == 3; })[0];
      this.intervalsList.title = lang.get('protocol.phase_support');

      this.fluency.executionSecondsLimit = this.fluency.executionSecondsLimit ? this.fluency.executionSecondsLimit.toString() : '3';

      let masteringCondition = this.mastering ? this.mastering.transferCondition : null;
      let rotationCondition = this.rotation ? this.rotation.transferCondition : null;
      let fluencyCondition = this.fluency ? this.fluency.transferCondition : null;

      this.masteringTransferCondition = masteringCondition.id ? masteringCondition.id : TRANSFER_CONDITION.ONE_TRIAL;
      this.rotationTransferCondition = rotationCondition.id ? rotationCondition.id : TRANSFER_CONDITION.ONE_TRIAL;
      this.fluencyTransferCondition = fluencyCondition.id ? fluencyCondition.id : TRANSFER_CONDITION.ONE_TRIAL;

      if(masteringCondition.id != TRANSFER_CONDITION.ONE_TRIAL) this.getTransferCondition(this.masteringConditionTransfer, masteringCondition);
      if(rotationCondition.id != TRANSFER_CONDITION.ONE_TRIAL) this.getTransferCondition(this.rotationConditionTransfer, rotationCondition);
      if(fluencyCondition.id != TRANSFER_CONDITION.ONE_TRIAL) this.getTransferCondition(this.fluencyConditionTransfer, fluencyCondition);


      this.masteringTaskType = this.mastering.taskType;
      this.rotationTaskType = this.rotation.taskType;

      this.masteringActive = this.mastering.active;
      this.rotationActive = this.rotation.active;
      this.intervalsActive = this.intervalsList.active;
      this.fluencyActive = this.fluency.active;

      this.masteringMinFieldCount = this.mastering.minFieldCount;
      this.rotationMinFieldCount = this.rotation.minFieldCount;
      this.fluencyMinFieldCount = this.fluency.minFieldCount;

      this.masteringMaxFieldCount = this.mastering.maxFieldCount;
      this.rotationMaxFieldCount = this.rotation.maxFieldCount;
      this.fluencyMaxFieldCount = this.fluency.maxFieldCount;

      this.hintListMastering = this.mastering.taskPrompts;
      this.hintListRotation = this.rotation.taskPrompts;

      this.masteringVisible = this.mastering.isPromptEnabled;
      this.rotationVisible = this.rotation.isPromptEnabled;

      this.changeStages(this.currentStage);
      this.setStageGenerate();

      setTimeout(() => {
        this.afterLoad = true;
      }, 100);

      Validator.extend('unique_task', {
        getMessage: attribute => lang.get('validation.unique_task',
            {attribute}),
        validate: async (task) => {
          let valid;
          let unique = 0;

          forIn(this.tasks, function(item) {
            if (item.description === task) {
              unique++;
            }
          });

          if (unique > 1) {
            valid = false;
          } else {
            valid = true;
          }

          return {valid};
        },
      });
    },

    watch: {
      masteringTransferCondition(newValue, oldValue){
        if (oldValue) {
          let mastering = filter(this.currentStage.phases, function(item) {
            return item.typeId == 1;
          })[0];
          mastering.transferCondition.id = newValue;
          this.setTransferCondition(mastering.transferCondition,
              this.masteringConditionTransfer);

        }
      },
      rotationTransferCondition(newValue, oldValue){
        if (oldValue) {
          let rotation = filter(this.currentStage.phases, function(item) {
            return item.typeId == 2;
          })[0];
          rotation.transferCondition.id = newValue;
          this.setTransferCondition(rotation.transferCondition,
              this.rotationConditionTransfer);

        }
      },
      fluencyTransferCondition(newValue, oldValue){
        if (oldValue){
          let fluency = filter(this.currentStage.phases, function(item) { return item.typeId == 4; })[0];
          fluency.transferCondition.id = newValue;
          this.setTransferCondition(fluency.transferCondition,
              this.fluencyConditionTransfer);

        }
      },
      masteringActive(newValue){

        if (this.afterLoad){

          let mastering = filter(this.currentStage.phases, function(item) { return item.typeId == 1; })[0];

          if(!newValue) {
            let taskCount = filter(this.tasks, task => {
              return task.phaseType == 1;
            }).length;

            if (taskCount) {
              this.modalView = true;
              this.phaseName = lang.get('protocol.mastering');
              this.currentPhaseType = 1;
            } else{
              mastering.active = newValue;
            }

          } else{
            mastering.active = newValue;
            this.errorPhaseCount = false;
          }
        }

      },
      rotationActive(newValue){
        if (this.afterLoad) {
          let rotation = filter(this.currentStage.phases, function(item) {
            return item.typeId == 2;
          })[0];

          if (!newValue) {
            let taskCount = filter(this.tasks, task => {
              return task.phaseType == 2;
            }).length;

            if (taskCount) {
              this.modalView = true;
              this.phaseName = lang.get('protocol.rotation');
              this.currentPhaseType = 2;
            } else {
              rotation.active = newValue;
            }

          } else {
            rotation.active = newValue;
            this.errorPhaseCount = false;
          }
        }
      },
      fluencyActive(newValue){
        if (this.afterLoad) {
          let fluency = filter(this.currentStage.phases, function(item) {
            return item.typeId == 4;
          })[0];

          if (!newValue) {
            let taskCount = filter(this.tasks, task => {
              return task.phaseType == 4;
            }).length;

            if (taskCount) {
              this.modalView = true;
              this.phaseName = lang.get('protocol.fluency');
              this.currentPhaseType = 4;
            } else {
              fluency.active = newValue;
            }

          } else {
            fluency.active = newValue;
            this.errorPhaseCount = false;
          }
        }
      },
      intervalsActive(newValue){
        if (this.afterLoad) {
          let intervals = filter(this.currentStage.phases, function(item) {
            return item.typeId == 3;
          })[0];

          if (!newValue) {
            let taskCount = filter(this.tasks, task => {
              return task.phaseType == 3;
            }).length;

            if (taskCount) {
              this.modalView = true;
              this.phaseName = lang.get('protocol.support');
              this.currentPhaseType = 3;
            } else {
              intervals.active = newValue;
            }

          } else {
            intervals.active = newValue;
            this.errorPhaseCount = false;
          }
        }
      },

      /*masteringMinFieldCount(newValue,oldValue){
        if (this.afterLoad && newValue > 0) {

          let mastering = filter(this.currentStage.phases, function(item) {
            return item.typeId == 1;
          })[0];
          this.oldMaxValue = this.masteringMaxFieldCount;
          if (this.masteringMaxFieldCount < newValue) {
            this.masteringMaxFieldCount = newValue;
          }
          let taskCount = filter(this.tasks, task => {
            return task.phaseType == 1 && task.fieldIndex < newValue;
          }).length;

          if (taskCount){
            this.modalViewField = true;
            this.minValue = newValue;
            this.oldMinValue = oldValue;
            this.maxValue = this.masteringMaxFieldCount;
            this.currentPhaseType = 1;

          } else{
            mastering.minFieldCount = newValue;
          }

        }
      },

      rotationMinFieldCount(newValue,oldValue){
        if (this.afterLoad && newValue > 0) {

          let rotation = filter(this.currentStage.phases, function(item) {
            return item.typeId == 2;
          })[0];
          this.oldMaxValue = this.rotationMaxFieldCount;
          if (this.rotationMaxFieldCount < newValue) {
            this.rotationMaxFieldCount = newValue;
          }
          let taskCount = filter(this.tasks, task => {
            return task.phaseType == 2 && task.fieldIndex < newValue;
          }).length;

          if (taskCount){
            this.modalViewField = true;
            this.minValue = newValue;
            this.oldMinValue = oldValue;
            this.maxValue = this.rotationMaxFieldCount;
            this.currentPhaseType = 2;

          } else{
            rotation.minFieldCount = newValue;
          }

        }
      },

      fluencyMinFieldCount(newValue,oldValue){
        if (this.afterLoad && newValue > 0) {

          let fluency = filter(this.currentStage.phases, function(item) {
            return item.typeId == 4;
          })[0];
          this.oldMaxValue = this.fluencyMaxFieldCount;
          if (this.fluencyMaxFieldCount < newValue) {
            this.fluencyMaxFieldCount = newValue;
          }
          let taskCount = filter(this.tasks, task => {
            return task.phaseType == 4 && task.fieldIndex < newValue;
          }).length;

          if (taskCount){
            this.modalViewField = true;
            this.minValue = newValue;
            this.oldMinValue = oldValue;
            this.maxValue = this.fluencyMaxFieldCount;
            this.currentPhaseType = 4;

          } else{
            fluency.minFieldCount = newValue;
          }

        }

      },

      masteringMaxFieldCount(newValue, oldValue){
        if (this.afterLoad && newValue > 0) {

          let mastering = filter(this.currentStage.phases, function(item) {
            return item.typeId == 1;
          })[0];
          this.oldMinValue = this.masteringMinFieldCount;
          if (this.masteringMinFieldCount > newValue) {
            this.masteringMinFieldCount = newValue;
          }
          let taskCount = filter(this.tasks, task => {
            return task.phaseType == 1 && task.fieldIndex > newValue;
          }).length;

          if (taskCount){
            this.modalViewField = true;
            this.maxValue = newValue;
            this.oldMaxValue = oldValue;
            this.minValue = this.masteringMinFieldCount;
            this.currentPhaseType = 1;

          } else{
            mastering.maxFieldCount = newValue;
          }

        }
      },

      rotationMaxFieldCount(newValue, oldValue){
        if (this.afterLoad && newValue > 0) {

          let rotation = filter(this.currentStage.phases, function(item) {
            return item.typeId == 2;
          })[0];
          this.oldMinValue = this.rotationMinFieldCount;
          if (this.rotationMinFieldCount > newValue) {
            this.rotationMinFieldCount = newValue;
          }
          let taskCount = filter(this.tasks, task => {
            return task.phaseType == 2 && task.fieldIndex > newValue;
          }).length;

          if (taskCount){
            this.modalViewField = true;
            this.maxValue = newValue;
            this.oldMaxValue = oldValue;
            this.minValue = this.rotationMinFieldCount;
            this.currentPhaseType = 2;

          } else{
            rotation.maxFieldCount = newValue;
          }

        }
      },

      fluencyMaxFieldCount(newValue, oldValue){
        if (this.afterLoad && newValue > 0) {

          let fluency = filter(this.currentStage.phases, function(item) {
            return item.typeId == 2;
          })[0];
          this.oldMinValue = this.fluencyMinFieldCount;
          if (this.fluencyMinFieldCount > newValue) {
            this.fluencyMinFieldCount = newValue;
          }
          let taskCount = filter(this.tasks, task => {
            return task.phaseType == 2 && task.fieldIndex > newValue;
          }).length;

          if (taskCount){
            this.modalViewField = true;
            this.maxValue = newValue;
            this.oldMaxValue = oldValue;
            this.minValue = this.fluencyMinFieldCount;
            this.currentPhaseType = 2;

          } else{
            fluency.maxFieldCount = newValue;
          }

        }
      },*/

    }

  };
</script>


// WEBPACK FOOTER //
// src/modules/protocols/components/TasksDTT.vue